import React from 'react';

interface GradientProfileIconProps {
  size?: number;
  className?: string;
}

const GradientProfileIcon: React.FC<GradientProfileIconProps> = ({ size = 18, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <g filter="url(#filter0_iii_572_4757)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3416 6.11538C12.3416 7.83596 10.9468 9.23077 9.22626 9.23077C7.50568 9.23077 6.11088 7.83596 6.11088 6.11538C6.11088 4.39481 7.50568 3 9.22626 3C10.9468 3 12.3416 4.39481 12.3416 6.11538ZM3.75 14.9423C3.75337 12.3626 6.2032 10.2721 9.22628 10.2692C12.2494 10.2721 14.6992 12.3626 14.7025 14.9423C14.7025 15.2291 14.4301 15.4615 14.0941 15.4615H4.35847C4.02242 15.4615 3.75 15.2291 3.75 14.9423Z"
        fill="url(#paint0_linear_572_4757)"
      />
    </g>
    <defs>
      <filter
        id="filter0_iii_572_4757"
        x="2.94203"
        y="3"
        width="14.4153"
        height="14.4615"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.577124" />
        <feGaussianBlur stdDeviation="0.577124" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_572_4757" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="2" />
        <feGaussianBlur stdDeviation="1.32739" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.125797 0 0 0 0 0.104989 0 0 0 0 0.478797 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_572_4757"
          result="effect2_innerShadow_572_4757"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.807974" dy="0.23085" />
        <feGaussianBlur stdDeviation="0.461699" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_572_4757"
          result="effect3_innerShadow_572_4757"
        />
      </filter>
      <linearGradient
        id="paint0_linear_572_4757"
        x1="3.75"
        y1="3.29764"
        x2="16.0434"
        y2="14.3954"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15CCCB" />
        <stop offset="0.492409" stopColor="#4987FF" />
        <stop offset="1" stopColor="#8B1CFA" />
      </linearGradient>
    </defs>
  </svg>
);

export default GradientProfileIcon;
